var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInvalidLink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 15.9999V34.6666M31.9999 42.6666H32.0266M58.6666 31.9999C58.6666 46.7275 46.7275 58.6666 31.9999 58.6666C17.2723 58.6666 5.33325 46.7275 5.33325 31.9999C5.33325 17.2723 17.2723 5.33325 31.9999 5.33325C46.7275 5.33325 58.6666 17.2723 58.6666 31.9999Z",
    stroke: "#F59E0B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInvalidLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/invalid-link.fd78cff4ce86f50ca2e53a82d4155aa8.svg";